import React, { useEffect } from 'react';
import { ArrowDownIcon } from '@cloudclevr/components';
import styles from './styles.module.css';
import cn from 'classnames';

export type SelectItem = {
  id?: string;
  name?: string;
  value?: string;
  disabled?: boolean;
};

type SelectProps = {
  items: SelectItem[];
  selected: string;
  selectOnChange: (value: string) => void;
  classNames?: string;
  testId?: string;
};

export const Select: React.FC<SelectProps> = ({
  items,
  selected,
  selectOnChange,
  classNames,
  testId = 'select',
}) => {
  const [open, setOpen] = React.useState(false);
  const [headerLabel, setHeaderLabel] = React.useState('Select');

  useEffect(() => {
    if (selected) {
      const selectedItem: SelectItem[] = items.filter((i) => i.id === selected);
      setHeaderLabel(selectedItem[0]?.name ?? 'Select');
    } else {
      setHeaderLabel('Select');
    }
  }, [items, selected]);

  const toggleOpen = () => {
    setOpen(!open);
  };

  const handleItemClick = (item: SelectItem) => {
    if (item.disabled) return;
    selectOnChange(item?.id ?? '');
    setHeaderLabel(item?.name ?? 'Select');
    setOpen(false);
  };

  return (
    <div className={cn(styles.wrapper, classNames)} data-testid={testId}>
      <button className="w-full" onClick={toggleOpen} data-testid={`${testId}-button`}>
        <span className={styles.header} data-testid={`${testId}-header`}>
          {headerLabel}
          <ArrowDownIcon size="3" classNames="w-5" />
        </span>
      </button>

      {open && (
        <ul className={styles.list}>
          <li className={styles.listItem} data-testid={`${testId}-option-default`} onClick={() => handleItemClick({})}>
            Select
          </li>

          {items.map((item) => (
            <li
              data-testid={`${testId}-option-${item.id}`}
              className={cn(styles.listItem, {
                [styles.disabled]: item.disabled,
              })}
              key={item.id}
              value={item.id}
              onClick={() => handleItemClick(item)}
            >
              {item.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
